import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, ValidatorFn } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import * as momentNS from 'moment';
import { CustomValidators } from '../validation-helper';
import { PopupPlacement } from '../../popup/popup.component';

const moment = momentNS;

@Component({
  selector: 'md-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [DatePipe]
})
export class DatepickerComponent extends AbstractFormControl implements OnInit {

  @Input() public formModel!: FormGroup;

  @Input() public id?: string;

  @Input() public popupPlacement: PopupPlacement = 'bottomLeft'

  /** Days of the week that cannot be selected */ 
  // @Input() public unavailableDays: number[] = [];

  /** Specific dates that cannot be selected */
  // @Input() public unavailableDates: Date[] = []

  private dateFormat = 'MM/dd/yyyy';

  private labelPatched = false;
  private modelPatched = false;

  static createFormGroup(model: FormControl, validators?: ValidatorFn[]): FormGroup {
    const dp = new DatePipe('en-US');
    return new FormGroup({
      model: model,
      label: new FormControl(dp.transform(model.value, 'MM/dd/yyyy'), {validators: validators, updateOn: 'blur'})
    });
  }

  constructor(private datePipe: DatePipe) {
    super();
  }

  ngOnInit() {
    // Validate formGroup structure
    if (!this.formModel) {
      throw new Error('No value is assigned to the [formGroup] input');
    } else if (!this.formModel.get('label')) {
      // tslint:disable-next-line:max-line-length
      throw new Error(`formGroup is missing required 'label' control. Use the static DatepickerComponent.createFormGroup method to get a formGroup that the DatepickerComponent expects.`);
    } else if (!this.formModel.get('model')) {
      // tslint:disable-next-line:max-line-length
      throw new Error(`formGroup is missing required 'model' control. Use the static DatepickerComponent.createFormGroup method to get a formGroup that the DatepickerComponent expects.`);
    }

    // Subscribe to input value changes
    // tslint:disable-next-line:no-non-null-assertion
    this.formModel.get('label')!.valueChanges.pipe(
      takeUntil(this.destroyed)
    ).subscribe(value => {
      this.labelValueChanged(value);
    });

    this.formModel.get('model')!.valueChanges.pipe(
      takeUntil(this.destroyed)
    ).subscribe(value => {
      this.modelValueChanged(value);
    })
  }

  private modelValueChanged(date: Date | null): void {
    if (this.modelPatched) {
      this.modelPatched = false;
      return;
    } else {
      this.labelPatched = true;
      if (date) {
        this.formModel.patchValue({
          label: this.datePipe.transform(date, this.dateFormat)
        });
      } else {
        this.formModel.patchValue({
          label: null
        });
      }

      // if (!this.popup.hidden) {
      //   this.formModel.get('label')!.markAsDirty();
      //   this.popup.close();
      // }
    }   
  }

  private labelValueChanged(value: any): void {
    if (this.labelPatched) {
      this.labelPatched = false;
      return;
    } else {
      if (value) {
        const date = moment(value).toDate();
        if (this.updateValidity(date)) {
          this.modelPatched = true;
          this.formModel.patchValue({
            model: date
          });
          this.formModel.patchValue({
            label: this.datePipe.transform(date, this.dateFormat)
          }, {emitEvent: false})
        }
      } else {
        this.modelPatched = true;
        this.formModel.patchValue({
          model: null
        });
      }
  
      // if (!this.popup.hidden) {
      //   this.popup.close();
      // }
    }
  }

  private updateValidity(date: any): boolean {
    const errors = CustomValidators.validDate(date);
    this.formModel.get('label')!.setErrors(errors);
    return errors === null;
  }
}
